/* SPF redesign — homepage behaviour: review carousel (spf-review-carousel) and the rotating hero review plate (spf-hero).
   Both auto-advance only on wide screens, pause while hovered or focused, and stay still under prefers-reduced-motion. */
(() => {
  const wide = window.matchMedia('(min-width: 641px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canAutoplay = () => wide.matches && !reducedMotion.matches && !document.hidden;

  /* Pause flag for an element: true while the pointer is over it or focus is inside it. */
  const trackHold = (element) => {
    const state = { hover: false, focus: false };
    element.addEventListener('mouseenter', () => { state.hover = true; });
    element.addEventListener('mouseleave', () => { state.hover = false; });
    element.addEventListener('focusin', () => { state.focus = true; });
    element.addEventListener('focusout', (event) => {
      if (!element.contains(event.relatedTarget)) state.focus = false;
    });
    return () => state.hover || state.focus;
  };

  const initCarousel = (root) => {
    const track = root.querySelector('[data-spf-carousel-track]');
    const items = [...root.querySelectorAll('[data-spf-carousel-item]')];
    const dotsWrap = root.querySelector('[data-spf-carousel-dots]');
    if (!track || items.length < 2) {
      root.querySelector('.spf-revcar__controls')?.setAttribute('hidden', '');
      return;
    }

    const step = () => items[1].offsetLeft - items[0].offsetLeft || items[0].offsetWidth;
    const current = () => Math.round(track.scrollLeft / step());
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    const goTo = (index) => {
      const target = items[Math.max(0, Math.min(items.length - 1, index))];
      track.scrollTo({ left: target.offsetLeft - items[0].offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    root.querySelector('[data-spf-carousel-prev]')?.addEventListener('click', () => goTo(current() - 1));
    root.querySelector('[data-spf-carousel-next]')?.addEventListener('click', () => (atEnd() ? goTo(0) : goTo(current() + 1)));

    const dots = items.map((item, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'spf-revcar__dot';
      dot.setAttribute('aria-label', `Omdöme ${index + 1} av ${items.length}`);
      dot.addEventListener('click', () => goTo(index));
      dotsWrap?.append(dot);
      return dot;
    });
    const updateDots = () => {
      const active = atEnd() ? items.length - 1 : current();
      dots.forEach((dot, index) => {
        if (index === active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    updateDots();
    track.addEventListener('scroll', updateDots, { passive: true });

    const delay = Number(root.dataset.autoplay) || 0;
    if (!delay) return;
    const held = trackHold(root);
    window.setInterval(() => {
      if (!canAutoplay() || held()) return;
      if (atEnd()) goTo(0);
      else goTo(current() + 1);
    }, delay);
  };

  const initPlate = (plate) => {
    const quotes = [...plate.querySelectorAll('[data-spf-plate-quote]')];
    if (quotes.length < 2) return;
    const held = trackHold(plate);
    let index = 0;
    window.setInterval(() => {
      if (!canAutoplay() || held()) return;
      quotes[index].hidden = true;
      index = (index + 1) % quotes.length;
      quotes[index].hidden = false;
    }, Number(plate.dataset.interval) || 6000);
  };

  /* Hero and carousel each include this script, so an element may be seen twice: initialise it once. */
  const once = (fn) => (element) => {
    if (element.dataset.spfReady) return;
    element.dataset.spfReady = 'true';
    fn(element);
  };

  const init = () => {
    document.querySelectorAll('[data-spf-carousel]').forEach(once(initCarousel));
    document.querySelectorAll('[data-spf-plate]').forEach(once(initPlate));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
